export function sortValiditiesByStartDesc(rows) {
  return (rows || []).slice().sort((a, b) => {
    const inicioA = a.inicioIso || "";
    const inicioB = b.inicioIso || "";

    if (inicioA !== inicioB) {
      if (!inicioA) return 1;
      if (!inicioB) return -1;
      return inicioA < inicioB ? 1 : -1;
    }

    return Number(b.validityId || 0) - Number(a.validityId || 0);
  });
}
